import { init as initApm } from '@elastic/apm-rum';

import { Environment } from './Environment';

// const initializeAppVersionCookie = () => {
//   document.cookie = `app_version=${Environment.getApplicationVersion()}`;
// };

const initializeElastic = () => {
  if (Environment.getElasticEnabled()) {
    initApm({
      serviceName: Environment.getElasticServiceName(),
      serverUrl: Environment.getElasticServerUrl(),
      serviceVersion: Environment.getElasticServiceVersion(),
      environment: Environment.getElasticEnvironment(),
    });
  }
};

export const preLoadSetup = () => {
  initializeElastic();
};
